import React, { useState, useCallback } from 'react';
import Header from './components/Header';
import CalculatorForm from './components/CalculatorForm';
import Results from './components/Results';
import Footer from './components/Footer';

const API_BASE = process.env.REACT_APP_API_URL || '';

function App() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCalculate = useCallback(async (formData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE}/api/calculate/single`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail?.[0]?.msg || err.detail || 'Calculation failed');
      }

      const data = await response.json();
      setResults({ calculation: data, inputs: formData });
    } catch (err) {
      setError(err.message);
      setResults(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <div className="calculator-layout">
          <div>
            <CalculatorForm onCalculate={handleCalculate} loading={loading} />
            {error && <div className="error-msg">{error}</div>}
          </div>
          <div>
            <Results results={results} loading={loading} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
